import { useGetNotificationsListQuery } from '../../infrastructure/api/notifications.api';

export function useNotificationsList(skip = false) {
  const { data, isLoading, isFetching, isError } = useGetNotificationsListQuery(
    undefined,
    { skip },
  );

  return {
    items: data ?? [],
    isLoading,
    isFetching,
    isError,
  };
}
